export const GET_CONTRACTS = '/api/Shipper/List';
export const SHIPPER_ACTUAL_DELIVERIES = '/api/Shipper/Details';

export const GET_PRODUCERS = '/api/Producer/List';
export const PRODUCER_ACTUAL_DELIVERIES = '/api/Producer/Details';
export const DOWNLOAD_PRODUCER_XML = '/api/Producer/Download';
export const DOWNLOAD_PRODUCER_EXCEL = '/api/Producer/Details/DownloadExcel';
export const DOWNLOAD_SHIPPER_XML = '/api/Shipper/Download';
export const DOWNLOAD_SHIPPER_EXCEL = '/api/Shipper/Details/DownloadExcel';
export const CVA_UPLOAD_LIST = '/api/CVA/Details';
export const CVA_DOWNLOAD = 'api/CVA/Download';
export const UPLOAD_PRODUCER_XML = '/api/Producer/Upload';
export const UPLOAD_SHIPPER_XML = '/api/Shipper/Upload';
export const M2_REPORT_LIST = '/api/M2Report/History';
export const M2_REPORT_DOWNLOAD = '/api/M2Report/Download';
export const M2_REPORT_MANUAL_UPLOAD = '/api/M2Report/Manual';
export const M2_REPORT_AUTOMATIC_UPLOAD = '/api/M2Report/Automatic';
export const M2_REPORT_UPLOAD_TO_BLOB = '/api/M2Report/UploadToBlob';
export const M2_REPORT_DOWNLOAD_WITH_Z_KEY = '/api/M2Report/DownloadWithZKey';
export const GET_COUNTERPARTY_STATEMENT_HISTORY =
  '/api/CounterpartyStatement/History';
export const GET_COUNTERPARTY_STATEMENT_DETAILS =
  '/api/CounterpartyStatement/List';
export const DOWNLOAD_COUNTERPARTY_STATEMENTS =
  '/api/CounterpartyStatement/Download';
export const UPLOAD_COUNTERPARTY_STATEMENTS_TO_ALIGNE =
  '/api/CounterpartyStatement/Upload';
export const SEND_STATEMENTS_TO_COUNTERPARTY =
  '/api/CounterpartyStatement/SendToCounterparty';

export const MESSAGES = {
  UPDATED: 'Shipper actual deliveries updated successfully!',
  REQUIRED_START_DATE: 'Start Date is required',
  REQUIRED_END_DATE: 'End Date is required',
  REQUIRED_UPLOAD_TYPE: 'Upload Type is required',
  REQUIRED_XML_TYPE: 'Please select producer or shipper',
  M2_REPORTS_IS_IN_PROGRESS: 'M2 Report generation is in processing state',
};

export const COUNTERPARTY_STATEMENTS = {
  Angus: 1,
  'Waldorf Production': 2,
  'Kistos Laggan': 3,
  'Idemitsu Norway': 4,
  Cnooc: 5,
  NEO: 6,
};

export const COUNTERPARTY_STATEMENTS_STICKY_COLUMNS = {
  Angus: 3,
  'Waldorf Production': 3,
  'Kistos Laggan': 3,
  'Idemitsu Norway': 3,
  Cnooc: 3,
  NEO: 1,
};
